var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no_data"},[_c('img',{attrs:{"src":require('static/img/nodata.png'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }